import { render, staticRenderFns } from "./touchDia.vue?vue&type=template&id=1c7a27d9&scoped=true&"
import script from "./touchDia.vue?vue&type=script&lang=js&"
export * from "./touchDia.vue?vue&type=script&lang=js&"
import style0 from "./touchDia.vue?vue&type=style&index=0&id=1c7a27d9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c7a27d9",
  null
  
)

export default component.exports